import { render, staticRenderFns } from "./VendorJoinRequestManagement.vue?vue&type=template&id=4f05472e&scoped=true&"
import script from "./VendorJoinRequestManagement.vue?vue&type=script&lang=js&"
export * from "./VendorJoinRequestManagement.vue?vue&type=script&lang=js&"
import style0 from "./VendorJoinRequestManagement.vue?vue&type=style&index=0&id=4f05472e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f05472e",
  null
  
)

export default component.exports